'use strict';

module.exports = {
  LANDING_FRAME_NAME: 'braintreethreedsecurelanding'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/three-d-secure/shared/constants.js
// module id = 246
// module chunks = 0